import { createSelector } from "reselect";
import get from "lodash/get";

const liquidOcrErrorDomain = state => get(state.api, "liquidURL.error", {});

const liquidSubmitOcrErrorDomain = state =>
  get(state.api, "liquidOCRRegister.error", {});

// ***************************************************************
// ********************** liquid error  makeSelect **********************
// ***************************************************************

export const liquidOcrErrorDataSelector = createSelector(
  liquidOcrErrorDomain,
  liquidUrl => liquidUrl
);

export const liquidSubmitOcrErrorDataSelector = createSelector(
  liquidSubmitOcrErrorDomain,
  liquidSubmitError => liquidSubmitError
);

export const makeSelectLiquidUrlErrorData = () => liquidOcrErrorDataSelector;

export const makeSelectLiquidSubmitErrorData = () =>
  liquidSubmitOcrErrorDataSelector;
